import { useState } from 'react'

import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { referredColumns } from './constants'
import useQueryGetPlayerReferred from '@/modules/manage-player/api/hooks/useQueryGetPlayerReferred'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { Button } from '@/common/ui/button'
import { Download } from 'lucide-react'
import { useMutationExportReferredPlayersCsv } from '@/modules/manage-player/api/hooks/useMutationExportReferredPlayersCsv'
import { ExportCsvAmountModal } from '@/common/components/ExportCsvAmountModal'

interface ReferredPlayerProps {
	playerId: string
}

export default function ReferredPlayer({ playerId }: ReferredPlayerProps) {
	const { pageSize, currentPage } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const exportCsvMutation = useMutationExportReferredPlayersCsv()
	const [showExportModal, setShowExportModal] = useState(false)

	const referredPayload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	const { data: referredData, isLoading: isReferredLoading } =
		useQueryGetPlayerReferred(playerId, referredPayload)

	const handleExportCsv = (amount: number) => {
		exportCsvMutation.mutate({
			playerId,
			startDate: dateFilter.startDate || undefined,
			endDate: dateFilter.endDate || undefined,
			take: amount || referredData?.total || 1000,
			skip: 0,
			filename: `referred_players_${playerId}`,
			columnMappings: {
				phone: 'สมาชิก',
				createdAt: 'วันที่สมัคร',
			},
		})
	}

	return (
		<div className="space-y-4">
			<div className="flex flex-col items-end gap-4">
				<Button
					variant="outline"
					onClick={() => setShowExportModal(true)}
					disabled={exportCsvMutation.isPending || !referredData?.data?.length}
					className="flex items-center gap-2"
					size="sm"
				>
					<Download className="h-4 w-4" />
					โหลด CSV
				</Button>
				<DateRangePicker />
				<DateRangeButtons />
			</div>
			<DataTablePaginate
				columns={referredColumns}
				data={referredData?.data || []}
				totalItems={referredData?.total || 0}
				isLoading={isReferredLoading}
			/>
			<ExportCsvAmountModal
				open={showExportModal}
				onOpenChange={setShowExportModal}
				onConfirm={handleExportCsv}
				defaultAmount={referredData?.total || 1000}
				maxAmount={100000}
				isLoading={exportCsvMutation.isPending}
			/>
		</div>
	)
}
